// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.160Z

export const heroes = [
  {
    "id": "neutral_lider_ulicy",
    "name_ru": "Лидер улицы",
    "name_en": "Street Leader",
    "faction": "neutral",
    "type": "hero",
    "rarity": "special",
    "archetype": "Уличный лидер",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 1,
    "hp": 10,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч: 3 урона выбранному вражескому юниту",
      "aura": "На 1-й линии твои юниты получают +1/0/0, на 2-й линии +0/1/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "enemy_choose",
      "effect": "damage",
      "value": "3",
      "uses": "1"
    },
    "dsl_aura": {
      "target": "composite",
      "effect": "composite",
      "value": "buff_stats:1/0/0@ally_aoe_line_1|buff_stats:0/1/1@ally_aoe_line_2"
    },
    "flavor_ru": "«Корпы делят небо. Я делю улицу.»",
    "ability_text_en": {
      "active": "1× per match: 3 damage to a chosen enemy unit",
      "aura": "On line 1 your units get +1/0/0, on line 2 +0/1/1"
    }
  }
];
